import TicketInputModal from '@/components/PatientModal/TicketInputModal.tsx';

import { ModalType } from '@/models/Modal.ts';
import { DailyAppointment } from '@/models/appointment/Appointment.ts';
import { UserAppointmentDto } from '@/models/call-system/dtos/user-appointment-dto.ts';

import { updateTicketNumber } from '@/services/appointmentService.ts';
import { closeModal, openModal } from '@/services/modalService.tsx';
import { showErrorNotification, showSuccessNotification } from '@/services/notificationService.ts';

interface UseTicketEditorParams {
    appointment: DailyAppointment;
    checkinData: UserAppointmentDto;
    onTicketUpdate?: () => Promise<void>;
}

export const useTicketEditor = ({
    appointment,
    checkinData,
    onTicketUpdate,
}: UseTicketEditorParams): { handleEditTicket: () => void } => {
    const handleEditTicket = (): void => {
        if (!checkinData?.number || !appointment) return;

        const handleTicketUpdate = async (new_ticket: string): Promise<void> => {
            const [success, message] = await updateTicketNumber(
                appointment,
                checkinData.number,
                new_ticket,
                checkinData
            );

            closeModal(ModalType.EDIT_TICKET);

            if (success) {
                showSuccessNotification(message);
                await onTicketUpdate?.();
            } else {
                showErrorNotification(message);
            }
        };

        openModal({
            modalId: ModalType.EDIT_TICKET,
            title: 'Ticketnummer ändern',
            children: (
                <TicketInputModal
                    initialTicket={checkinData.number}
                    onConfirm={handleTicketUpdate}
                    onCancel={() => closeModal(ModalType.EDIT_TICKET)}
                />
            ),
            withCloseButton: true,
            closeOnEscape: true,
        });
    };

    return { handleEditTicket };
};
